<script>
  import crud from './Base/Crud'
  export default {
    mixins: [crud],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'新增Banner', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '分类',
              prop: 'cat_id',
              type: 'select',
              props: {label: 'title', value: 'id'},
              dicUrl: this.config.baseURL + '/dic/banner/category',
              hide: true, // 隐藏列
              row: true
            },
            {
              label: '标题',
              prop: 'title',
              headerAlign: 'left',
              align: 'left',
              row: true
            },
            {
              label: '图片',
              prop: 'filepaths',
              // dataType: 'string', // 单图不要此属性
              type: 'upload',
              listType: 'picture-img', // 单图
              // listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24
            },
            {
              label: '排序id',
              prop: 'sort_id',
              type: 'number',
              tip: '排序ID越小越靠前',
              value: 100,
              span: 6,
            },
          ]
        }
      }
    }
  }
</script>
